import { JsonApiClient } from "@/modules/api/utils/createJsonApiClient/createJsonApiClient";

import { completeSubtaskResourcePath } from "../resources/subtask/subtaskResourceConsts";

export function undoSubtaskCompletionMutation(jsonApi: JsonApiClient) {
  return ({
    userGroupId,
    subtaskId,
  }: {
    userGroupId: string;
    subtaskId: string;
  }) =>
    jsonApi.delete({
      path: completeSubtaskResourcePath(userGroupId, subtaskId),
    });
}
